import React, { useEffect, useState } from 'react';
import { useContactModal } from '../common/ContactModalContext';
import './Banner.css';
import { homePageContent } from '../../content/homePage';
import partner1 from '../../images/partners/logo-1.png';
import partner2 from '../../images/partners/logo-2.png';

const ArrowRight = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 12h14M12 5l7 7-7 7" />
  </svg>
);

const PlayIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
    <path d="M8 5v14l11-7z" />
  </svg>
);

/* Decorative flower: 4 rounded petals + center circle */
const FlowerVector = ({ className }) => (
  <svg className={className} viewBox="0 0 48 48" fill="currentColor" aria-hidden="true">
    <circle cx="24" cy="24" r="5" />
    <circle cx="24" cy="10" r="9" />
    <circle cx="38" cy="24" r="9" />
    <circle cx="24" cy="38" r="9" />
    <circle cx="10" cy="24" r="9" />
  </svg>
);

const Banner = ({
  title,
  titleLine2,
  subtitle,
  imageUrl,
  imageRight,
  imageRightBanner,
  ctaText,
  ctaLink,
  minimal,
  split,
  dark,
  sectionHeading,
  tags,
  emailPlaceholder,
  demoCtaText,
  companiesText,
}) => {
  const [visible, setVisible] = useState(false);
  const [email, setEmail] = useState('');
  const { openContactModal } = useContactModal();
  const defaultImage = 'https://images.unsplash.com/photo-1523240795612-9a054b0db644?w=1600&q=80';
  const defaultTitle = 'Unlock Your Potential';
  const defaultSubtitle = 'Learn, grow, and achieve more with InfinySkills. Your journey to mastery starts here.';
  const defaultImageRight = 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=800&q=80';
  const defaultTags = ['AI First Approach'];

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 150);
    return () => clearTimeout(t);
  }, []);

  const sectionStyle = minimal ? { background: '#fff' } : { backgroundImage: `url(${imageUrl || defaultImage})` };

  if (dark) {
    const b = homePageContent.banner;
    const tagList = tags && tags.length > 0 ? tags : defaultTags;
    return (
      <section className="banner banner-dark">
        <div className="banner-dark-bg" />
        <div className="banner-dark-grid" />
        <div className="banner-dark-inner">
          <div className={`banner-dark-left animate-fade-in-left ${visible ? 'animate-visible' : ''}`}>
            <div className="banner-dark-tags">
              {tagList.map((tag, i) => (
                <span key={i} className="banner-dark-tag">• {tag}</span>
              ))}
            </div>
            <h1 className="banner-dark-title">
              {title || b.title}
            </h1>
            <p className="banner-dark-desc">
              {subtitle || b.subtitle}
            </p>
            <div className="banner-partner-sec">
              <div className="banner-partner-sec-img">
                <img src={partner1} alt="Salesforce partner" />
              </div>
              <div className="banner-partner-sec-img">
                <img src={partner2} alt="KonfHub partner" />
              </div>
            </div>
            <div className="banner-dark-cta-row">
              {/* <input
                type="email"
                placeholder={emailPlaceholder || 'Enter your mail...'}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="banner-dark-input"
              /> */}
             <div className="banner-dark-input">Have any questions? Let's Talk!</div> 
              <a
                href={ctaLink || b.ctaLink}
                className="banner-dark-demo-btn"
                {...(/^https?:\/\//i.test(ctaLink || b.ctaLink) && { target: '_blank', rel: 'noopener noreferrer' })}
              >
                <span>{demoCtaText || b.demoCtaText}</span>
                <span className="banner-dark-demo-arrow"><ArrowRight /></span>
              </a>
            </div>
            <p className="banner-dark-companies">{companiesText || b.companiesText}</p>
            {/* <div className="banner-dark-logos">
              <span className="banner-dark-logo">AUTODESK</span>
              <span className="banner-dark-logo">Microsoft</span>
              <span className="banner-dark-logo">Adobe</span>
            </div> */}
          </div>
          <div className={`banner-dark-right animate-fade-in-right ${visible ? 'animate-visible' : ''}`}>
            {/* <div className="banner-dark-image-blob">
              <FlowerVector className="banner-dark-flower banner-dark-flower-tl" />
              <FlowerVector className="banner-dark-flower banner-dark-flower-br" />
              <img src={imageRight || defaultImageRight} alt="" loading="lazy" />
            </div>
            <div className="banner-dark-card banner-dark-watch">
              <span className="banner-dark-play"><PlayIcon /></span>
              <div>
                <span className="banner-dark-watch-text">Watch Reel</span>
                <span className="banner-dark-watch-time">1:52 min</span>
              </div>
            </div>
            <div className="banner-dark-card banner-dark-asterisk">
              <span className="banner-dark-asterisk-icon">*</span>
            </div>
            <div className="banner-dark-card banner-dark-income">
              <h4>Total Income</h4>
              <p className="banner-dark-income-row">This Week <strong>$8.964</strong> <span className="banner-dark-decrease">-13%</span></p>
              <p className="banner-dark-income-row">This Month <strong>$23.187</strong> <span className="banner-dark-increase">+2.5%</span></p>
              <div className="banner-dark-bars">
                {['S', 'M', 'T', 'W', 'T', 'F', 'S'].map((d, i) => (
                  <span key={i} className="banner-dark-bar" style={{ height: `${30 + (i * 8) % 50}%` }} title={d} />
                ))}
              </div>
            </div> */}

            <div className="banner-dark-image-blob">
              <img src={imageRightBanner || defaultImageRight} alt="" loading="lazy" />
            </div>
          </div>
        </div>
      </section>
    );
  }

  if (split) {
    return (
      <section className="banner banner-split">
        {sectionHeading && (
          <h2 className="banner-split-section-heading">{sectionHeading}</h2>
        )}
        <div className="banner-split-inner">
          <div className={`banner-split-text ${visible ? 'banner-split-text-visible' : ''}`}>
            <h1 className="banner-split-title">
              {title || 'Creative'}
              {titleLine2 && <span className="banner-split-title-line2">{titleLine2}</span>}
            </h1>
            {subtitle && <p className="banner-split-subtitle">{subtitle}</p>}
            {ctaText && (
              <button type="button" className="banner-split-cta" onClick={openContactModal}>
                {ctaText}
              </button>
            )}
          </div>
          <div className={`banner-split-image-wrap ${visible ? 'banner-split-image-visible' : ''}`}>
            <img
              src={imageRight || defaultImageRight}
              alt=""
              className="banner-split-image"
            />
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className={`banner ${minimal ? 'banner-minimal' : ''}`} style={sectionStyle}>
      {!minimal && <div className="banner-overlay" />}
      <div className={`banner-content animate-fade-in-up ${visible ? 'animate-visible' : ''}`}>
        <h1 className="banner-title">{title || defaultTitle}</h1>
        <p className="banner-subtitle">{subtitle || defaultSubtitle}</p>
        {ctaText && (
          <button type="button" className="banner-cta" onClick={openContactModal}>
            {ctaText}
          </button>
        )}
      </div>
    </section>
  );
};

export default Banner;
